// Panelin TEK şifre kuralı. Şifre belirleyen/değiştiren tüm ekranlar (Profil > Güvenlik,
// Şifremi Unuttum) bunu kullanır: kural iki ekranda ayrı yazıldığında "Şifremi Unuttum"
// üzerinden 6 haneli zayıf şifre belirlenebiliyordu (backend'de karmaşıklık doğrulaması yok).
export function getPasswordValidationMessage(value) {
  const password = String(value || "");
  if (!password) return "Lütfen yeni şifre alanını doldurunuz.";
  if (/\s/.test(password)) return "Şifre boşluk içeremez.";
  if (password.length < 8) return "Şifre en az 8 karakter olmalıdır.";
  if (!/[A-Za-zÇĞİÖŞÜçğıöşü]/.test(password)) return "Şifre en az bir harf içermelidir.";
  if (!/\d/.test(password)) return "Şifre en az bir rakam içermelidir.";
  if (!/[^A-Za-zÇĞİÖŞÜçğıöşü0-9\s]/.test(password)) return "Şifre en az bir özel karakter içermelidir.";
  return "";
}

export function isPasswordValid(value) {
  return getPasswordValidationMessage(value) === "";
}
